import { DescriptionWithArticleProps } from "@/utils/formatCategoryPage";
import { injectPurifiedHTML } from "@/utils/injectPurifiedHTML";
import { removeEmptyRel } from "@/utils/removeEmptyRel";
import styles from "./DescriptionWithArticle.module.scss";

export const DescriptionWithArticle = ({
  title,
  articles,
}: DescriptionWithArticleProps) => {
  return (
    <div className={styles.categoryDescription}>
      <h2 className={styles.title}>{title}</h2>
      {articles.map((article, index: number) => (
        <div className={styles.description} key={index}>
          {article.title && (
            <h3 className={styles.descriptionTitle}>{article.title}</h3>
          )}
          <div
            className={styles.descriptionText}
            dangerouslySetInnerHTML={injectPurifiedHTML(
              removeEmptyRel(article.text)
            )}
          />
        </div>
      ))}
    </div>
  );
};
